import { CONVERSATION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ConversationPropertyReferenceResolver from 'reference-resolvers/resolvers/ConversationPropertyReferenceResolver';
import ObjectDefinitionRecord from 'customer-data-filters-ui/objectDefinitionProvider/ObjectDefinitionRecord';
const Conversation = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  objectTypeId: CONVERSATION_TYPE_ID,
  getPropertyResolver: () => ConversationPropertyReferenceResolver,
  referenceObjectType: 'CONVERSATION_PROPERTIES'
});
export default Conversation;